import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';
import {UIIconName} from '../../ui-icon/ui-icon.component';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ui-radio',
    templateUrl: 'ui-radio.component.html'
})
export class UIRadioComponent implements AfterViewInit {
    @Input() selected = false;
    @Input() value: any;
    @Input() label: string;
    @Input() style: 'default' | 'label' | 'avatar' | 'icon' | 'button' = 'default';
    @Input() mode: 'default' | 'primary' | 'disabled' = 'default';
    @Input() icon: UIIconName;
    @Input() initials: string;
    @Input() disabled = false;
    @Input() loading = false;
    @Input() showIcon = true;

    constructor(
        private host: ElementRef<HTMLElement>
    ) {
    }

    get labelMode() {
        switch (this.mode) {
            case 'primary':
                if (this.style === 'button' && this.selected) {
                    return 'overPrimary';
                }
                return this.mode;
            case 'default':
                if (this.selected) {
                    return 'primary';
                }
                return this.mode;
            default:
                return this.mode;
        }
    }

    ngAfterViewInit() {
        this.applyDefaultStyling();
        this.host.nativeElement.addEventListener('click', () => {
            this.select();
        });
    }

    applyDefaultStyling() {
        this.host.nativeElement.classList.add('≈cursor-pointer', '≈w-fit');
    }

    select = () => {
    }; // Set by UIRadioGroupComponent
}
